let Melda = window.Melda || {};

if (typeof fbq === "undefined") {
	var fbq = function(a, b, c) {
		console.log('debug facebook', a, b, c);
	};
}

Melda.event = function(event, options) {
	return;
	// fbq('track', event, options);
};

// call every time
Melda.event('PageView');

$('.btn-basket').on('click', function() {
	Melda.event('AddToCart');
});

$('.checkout-button').on('click', function() {
	Melda.event('InitiateCheckout');
});

$('#frm-newsletterForm').on('submit', function() {
	Melda.event('Lead');
});

$('.downloads-universal-installer a').on('click', function() {
	Melda.event('Lead');
});

window.Melda = Melda;
